import { Box, BoxProps, Container, Divider, VStack } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'

import { getBrand } from '@lib/util/brand-handler'
import BrandLayout from '@layouts/brand-layout'
import Head from '@modules/common/components/head'
import Hero from '../supplement/hero'

import useAosAnimation from '@common/hooks/use-aos-animation'
import Features from './features'
import Body from './body'
import ProductCard from './prduct-card'
import ProductCardRight from './prduct-card-right'
import ExclusiveOffer from './exclusive-offer'
import ProductCard01 from './prduct-card-01'
import ProductCard02 from './prduct-card-02'
import ProductCard03 from './prduct-card-03'
import ProductCard04 from './prduct-card-04'
import ProductCard05 from './prduct-card-05'
import ProductCard06 from './prduct-card-06'
import ProductCard07 from './prduct-card-07'
import ProductCard08 from './prduct-card-08'
import Certification from './certification'
import Assurance from './assurance'

export const CONTAINER_WIDTH = {
  LARGE: 1366,
  MEDIUM: 992,
  SMALL_MEDIUM: 768,
  SMALL: 600
}

interface BgWrapperProps {
  url: string
  children?: React.ReactNode
}

const BgWrapper = ({ url, children, ...props }: BgWrapperProps & BoxProps) => {
  return (
    <Box
      bgImage={`url(${url})`}
      w="100%"
      bgSize="cover"
      bgPosition="center"
      {...props}
    >
      {children}
    </Box>
  )
}

export const MainContainer = (props: BoxProps) => {
  return (
    <Container
      maxW={{
        base: CONTAINER_WIDTH.SMALL,
        md: CONTAINER_WIDTH.SMALL_MEDIUM,
        lg: CONTAINER_WIDTH.MEDIUM,
        xl: CONTAINER_WIDTH.LARGE
      }}
      {...props}
    />
  )
}

const Supplement = () => {
  const { data } = useQuery(['brand', 'healthplus'], () =>
    getBrand('healthplus')
  )

  useAosAnimation({
    duration: 600,
    once: true
  })

  if (!data) return null

  const { title, metadata, productSection, color } = data

  return (
    <>
      <Head title={title} description={metadata.meta_descrtiption} />
      <BrandLayout
        name={title}
        color={color || '#E31C5A'}
        brand={data}
        productSection={productSection}
      >
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'flex-start'}
          gap={0}
        >
          {/* <Hero /> */}
          <BgWrapper
            data-aos="fade-up"
            url={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-page-1-1730454263925.png'
            }
            position="relative"
            bgSize="cover"
            bgPosition="top"
          >
            <Hero />
          </BgWrapper>
        </VStack>
        <Box bg="#e5e4d7">
          <MainContainer>
            <Features />
          </MainContainer>
        </Box>

        <BgWrapper
          data-aos="fade-up"
          url={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/Copy%20of%20Health%2B%20Japanese%20Kampo%20Supplement%20%EF%BF%BD%2Cn%22%EF%BF%BD%20Microsite-1734403746362.png'
          }
          position="relative"
          bgSize="cover"
          bgPosition="top"
        >
          <Certification />
        </BgWrapper>
        {/* <Assurance /> */}
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'flex-start'}
          gap={0}
        >
          <BgWrapper
            data-aos="fade-up"
            url={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-body-1730951900128.png'
            }
            position="relative"
            bgSize="cover"
            bgPosition="top"
            bgColor="#e5e4d7"
          >
            <Body />
          </BgWrapper>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard01 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard02 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard03 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard04 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard05 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard06 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard07 />
            <Divider bg="#9cb259" w="100%" height="2px" />
          </MainContainer>
        </VStack>
        <VStack
          w="100%"
          alignItems="center"
          justifyContent={'center'}
          gap={0}
          bgColor="#e5e4d7"
        >
          <MainContainer>
            <ProductCard08 />
          </MainContainer>
        </VStack>
        <VStack w="100%" alignItems="center" justifyContent={'center'} gap={0}>
          <ExclusiveOffer />
        </VStack>
      </BrandLayout>
    </>
  )
}

export default Supplement
